import { Button, Checkbox, FormField, Grid, Input, Link, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import React, { useEffect, useMemo, useState } from 'react';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';

//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import Favorites from '../../../../components/extras/Favorites';
import SelectPaging from '../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../commons/functions';


export const MasterGroups = () => {
    const { menu } = useGlobalState();

    type ItemGroup = {
        idGroup: number;
        group: string;
        groupCode: string;
        usersCount: number;
        jsonMenu: number[];
    }
    interface MenuItem {
        idMenu: number;
        text: string;
        items?: MenuItem[];
        type?: string;
        href?: string;
        section?: string;
    }


    //const storeAdmin = useStoreAdmin();


    const [helpOpen, setHelpOpen] = useState(false);
    const [sideOpen, setSideOpen] = useState(false);
    const [showGroup, setShowGroup] = useState(false);
    const { parameters } = useGlobalState();

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();


    const [group, setGroup] = useState<ItemGroup>()
    const [groups, setGroups] = useState<ItemGroup[]>([])
    const [menus, setMenus] = useState<MenuItem[]>([]);

    const [filterGroups, setFilterGroups] = useState("")

    /*
    useEffect(() => {
        if (idGroup === 0) {
            handleGetGroups()
        } else {
            handleGetGroupDetail(idGroup)
        }
    }, [idGroup]);
    */

    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");

            if (id) handleGetGroupDetail(parseInt(id));
            else handleGetGroups();
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);



    const [filteringText, setFilteringText] = useState("")

    const filtered = useMemo(() => {
        //if (!filterAccountsPlans.trim()) return accountPlans;
        let filtered = groups;
        if (filteringText.trim()) {
            const terms = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
            filtered = filtered.filter(item => {
                const haystack = [
                    item.group ?? "",
                    item.groupCode ?? "",
                    item.idGroup.toString(),
                ].join(" ").toLowerCase();

                return terms.every(term => haystack.includes(term));
            });
        }

        return filtered;
    }, [groups, filteringText]);
    const pageSize = 10;
    const [currentPageIndex, setCurrentPageIndex] = useState(1)
    const paginated = filtered.slice((currentPageIndex - 1) * pageSize, currentPageIndex * pageSize);



    const handleGetGroupDetail = async (idGroup: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/groups/get',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({ idGroup: idGroup })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.group) {
                setGroup(data.group)
                setMenus(data.menus)
                setShowGroup(true)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleGetGroups = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/groups/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({})
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.groups) {
                setGroup(undefined)
                setGroups(data.groups)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveMenu = async () => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/groups/update',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    idGroup: group?.idGroup,
                    jsonMenu: checkedIds
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }
            setShowGroup(false)
            const data = await response.json();
            if (data.code === 0) {
                if (data.groups) {
                    setGroups(data.groups)
                    window.location.hash = "#masters/groups"
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
        }
    };
    useEffect(() => {
        //handleGetGroups()

    }, []);
    // Initialize state with those IDs checked
    const [checkedItems, setCheckedItems] = React.useState<Record<number, boolean>>({});

    // When group.jsonMenu arrives, update checkedItems
    React.useEffect(() => {
        if (group?.jsonMenu) {
            const initial = group.jsonMenu.reduce((acc: Record<number, boolean>, id: number) => {
                acc[id] = true;
                return acc;
            }, {});
            setCheckedItems(initial);
        }
    }, [group?.jsonMenu]);

    const updateParentState = (
        updated: Record<number, boolean>,
        parentId: number | null
    ) => {
        if (!parentId) return;

        const parent = findItemById(menus, parentId);
        if (parent && parent.items) {
            const anyChildChecked = parent.items.some((c) => updated[c.idMenu]);
            updated[parent.idMenu] = anyChildChecked;

            // keep going up the tree
            const grandParent = findParentId(menus, parentId);
            updateParentState(updated, grandParent);
        }
    };
    const toggleChecked = (item: MenuItem, checked: boolean, parentId: number | null = null) => {
        setCheckedItems((prev) => {
            let updated = { ...prev, [item.idMenu]: checked };

            // if parent → toggle descendants
            if (item.items && item.items.length > 0) {
                const childIds = getDescendantIds(item);
                for (const cid of childIds) {
                    updated[cid] = checked;
                }
            }

            // update parent(s)
            if (parentId !== null) {
                updateParentState(updated, parentId);
            }

            return updated;
        });
    };
    // Returns an array of descendant IDs (numbers)
    const getDescendantIds = (item: MenuItem): number[] => {
        let ids: number[] = [];
        if (item.items) {
            for (const child of item.items) {
                ids.push(child.idMenu);
                ids = ids.concat(getDescendantIds(child));
            }
        }
        return ids;
    };

    // Returns parent ID or null
    const findParentId = (
        items: MenuItem[],
        id: number,
        parentId: number | null = null
    ): number | null => {
        for (const item of items) {
            if (item.idMenu === id) return parentId;
            if (item.items) {
                const found = findParentId(item.items, id, item.idMenu);
                if (found !== null) return found;
            }
        }
        return null;
    };

    // Returns MenuItem or null
    const findItemById = (items: MenuItem[], id: number): MenuItem | null => {
        for (const item of items) {
            if (item.idMenu === id) return item;
            if (item.items) {
                const found = findItemById(item.items, id);
                if (found) return found;
            }
        }
        return null;
    };

    const renderMenu = (items: MenuItem[], parentId: number | null = null): JSX.Element => (
        <ul style={{ listStyle: "none", paddingLeft: "1em" }}>
            {items.map((item: MenuItem) => (
                <li key={item.idMenu}>
                    <Checkbox
                        checked={!!checkedItems[item.idMenu]}
                        onChange={({ detail }) => toggleChecked(item, detail.checked, parentId)}
                    >
                        {item.text} [{item.idMenu}]
                    </Checkbox>

                    {/* pass current item.idMenu as parentId for children */}
                    {item.items && renderMenu(item.items, item.idMenu)}
                </li>
            ))}
        </ul>
    );

    const checkedIds: number[] = Object.keys(checkedItems || {})
        .filter((key) => checkedItems[Number(key)])
        .map((key) => Number(key));


    useEffect(() => {
        //if (checkedIds && checkedIds.length > 0)
        //    handleSaveMenu()

    }, [checkedIds]);
    return (
        <CustomAppLayout
            toolsHide


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    {group && (
                        <>
                            <Header
                                variant="h2"
                                description={`ID ${group?.idGroup}`}
                                actions={
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button onClick={() => navigate('masters/groups')}>Volver a la lista</Button>
                                        <Favorites />
                                    </SpaceBetween>
                                }>
                                Detalle del grupo <em>{group?.group}</em>
                            </Header>

                            <Grid gridDefinition={[{ colspan: 6 }, { colspan: 3 }, { colspan: 3 }]}>
                                <div>
                                    <FormField label={"Glosa"}>
                                        <Input value={group?.group || ""}
                                            onChange={(detail) => {
                                            }}
                                        />
                                    </FormField>
                                </div>
                                <div>
                                    <FormField label={"Etqiueta"}>
                                        <Input value={group?.groupCode || ""}
                                            onChange={(detail) => {
                                            }} />
                                    </FormField>
                                </div>
                                <div>
                                    <FormField label={<div style={{ color: "white" }}>{"·"}</div>}>
                                        <Button variant="primary" onClick={handleSaveMenu}>Guardar</Button>
                                    </FormField>
                                </div>

                            </Grid>

                            {menus && renderMenu(menus)}
                        </>
                    )}
                    {!group && (
                        <SpaceBetween direction="vertical" size="xs">
                            <Header actions={<Favorites />}
                                counter={filteringText === "" ? groups.length ? `(${groups.length})` : "" : `${filtered.length} de ${groups.length}`}
                            >Grupos</Header>
                            <Table

                                filter={
                                    <FormField>
                                        <TextFilter
                                            filteringText={filteringText}
                                            filteringPlaceholder="Buscar..."
                                            onChange={({ detail }) => setFilteringText(detail.filteringText)}
                                        />
                                    </FormField>
                                }
                                pagination={
                                    <SpaceBetween direction="horizontal" size="xs" alignItems="center">

                                        {filtered.length > parameters.pageSize && (
                                            <Pagination
                                                currentPageIndex={currentPageIndex}
                                                pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                            />
                                        )}

                                        {filtered.length > 0 && (

                                            <SelectPaging onSelect={(pageSize) => {
                                                setCurrentPageIndex(1);
                                                setParameters({ ...parameters, pageSize: pageSize });
                                            }} />
                                        )}
                                    </SpaceBetween>
                                }

                                variant="embedded"

                                columnDefinitions={[
                                    {
                                        id: "groups",
                                        header: "Grupo",
                                        cell: item => item.group,
                                    },
                                    {
                                        id: "groupCode",
                                        header: "Código",
                                        cell: item => item.groupCode,
                                    },
                                    {
                                        id: "users",
                                        header: "Usuarios",
                                        cell: item => <Link href={`#masters/groups.users?id=${item.idGroup}`}>{item.usersCount}</Link>,
                                    },
                                    {
                                        id: "jsonMenu",
                                        header: "Módulos",
                                        cell: item => <Link href={`#masters/groups?id=${item.idGroup}`}>{item.jsonMenu.length}</Link>,
                                    },
                                ]}
                                items={paginated ?? []}
                            />
                        </SpaceBetween>
                    )}
                </>
            }

        />
    );
};


